import { Box, Table, Tbody, Td, Th, Thead, Tr, Textarea, FormControl, FormErrorMessage, Tooltip } from '@chakra-ui/react'
import { useFormContext } from 'react-hook-form'

export function ObservacaoSection() {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  return (
    <Box borderWidth="1px" borderColor="gray.200" borderRadius="8px">
      <Table variant="simple" size="md">
        <Thead bg="#EFEFEF">
          <Tr>
            <Th fontSize="12px" fontWeight="normal" px={4} py={2} color="#313E44">
              OBSERVAÇÃO
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td px={0} py={0}>
              <FormControl isInvalid={!!errors.observacao}>
                <Textarea
                  {...register('observacao')}
                  rows={3}
                  placeholder="Digite aqui as observações importantes para este pedido..."
                  border="none"
                  p={4}
                  fontSize="12px"
                  color="#313E44"
                  _focus={{
                    border: 'none',
                    boxShadow: 'none',
                  }}
                  _placeholder={{ color: '#313E44', opacity: 0.7 }}
                />
                {errors.observacao && (
                  <Tooltip label={errors.observacao.message} hasArrow placement="top">
                    <FormErrorMessage fontSize="10px" px={4} isTruncated maxW="100%">
                      {errors.observacao.message}
                    </FormErrorMessage>
                  </Tooltip>
                )}
              </FormControl>
            </Td>
          </Tr>
        </Tbody>
      </Table>
    </Box>
  )
}
